module.exports = __webpack_public_path__ + "static/ack-15129f0ae494d45620befc522c879735.jpg";